import { Component, OnInit } from '@angular/core'
import {
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog'
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/input'
import { MatInput } from '@angular/material/input'
import { MatButton } from '@angular/material/button'
import { MatSlideToggle } from '@angular/material/slide-toggle'
import { MatProgressBar } from '@angular/material/progress-bar'
import moment from 'moment'
import { StatusVooConfiguracaoService } from '../../../core/services/status-voo/status-voo-configuracao.service'
import { SnackbarCustomService } from '../../../shared/components/snackbar/snackbar-custom.service'

@Component({
  selector: 'modal-status-voo-config',
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatButton,
    MatSlideToggle,
    MatProgressBar,
  ],
  templateUrl: './modal-status-voo-config.component.html',
  styleUrl: './modal-status-voo-config.component.scss',
})
export class ModalStatusVooConfigComponent implements OnInit {
  form: FormGroup
  loading = false
  config: any = null

  constructor(
    private dialogRef: MatDialogRef<ModalStatusVooConfigComponent>,
    private fb: FormBuilder,
    private statusVooService: StatusVooConfiguracaoService,
    private snackbar: SnackbarCustomService,
  ) {
    this.form = this.fb.group({
      intervaloAtualizacaoMinutos: [5, [Validators.required, Validators.min(1)]],
      ativo: [true],
    })
  }

  ngOnInit() {
    this.loadConfig()
  }

  loadConfig() {
    this.loading = true
    this.statusVooService.getConfiguracao().subscribe({
      next: (res: any) => {
        this.loading = false
        if (res.data) {
          this.config = res.data
          this.form.patchValue({
            intervaloAtualizacaoMinutos: res.data.intervaloAtualizacaoMinutos,
            ativo: res.data.ativo,
          })
        }
      },
      error: () => {
        this.loading = false
        this.snackbar.error('Não foi possível carregar a configuração.')
      },
    })
  }

  save() {
    if (this.form.invalid) return
    this.loading = true
    this.statusVooService.saveConfiguracao(this.form.value).subscribe({
      next: (res: any) => {
        this.loading = false
        this.snackbar.success(res.message || 'Configuração salva com sucesso!')
        this.dialogRef.close(true)
      },
      error: (err: any) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
    })
  }

  close() {
    this.dialogRef.close()
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '-'
    return moment(dateStr).format('DD/MM/YYYY HH:mm')
  }
}
